export const configSSO = {
  issuer: 'https://sts-acc.inforius.be',
  postLogoutRedirectUri: 'https://idep-bo-acc.myinforius.be/',
  redirectUri: 'https://idep-bo-acc.myinforius.be/callback',
  clientId: 'idep_backoffice',
  oidc: true,
  userinfoEndpoint: 'https://sts-acc.inforius.be/connect/userinfo',
  useSilentRefresh: true,
  scope: 'openid profile email idep.backoffice.api',
  showDebugInformation: false,
  silentRefreshRedirectUri:
    'https://idep-bo-acc.myinforius.be/silent-renew.html',
  responseType: 'code',
  enableLogConsole: false,
};
